import React from "react";
import "./introImg.css"; // Make sure this path is correct
import introScreen from "../../assets/images/IntroScreen.png";
// import introImg from "../../assets/images/introImage.svg";
import introImg from "../../assets/images/introLogo.svg";

const IntroImg = () => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        // src='https://d1ccopf5cw1hft.cloudfront.net/s3data/ufw_logo.png'
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/MemeTv-logo.png"
        className="grow-img"
        style={{ width: "65%" }}
        alt="border"
      />
    </div>
  );
};

export default IntroImg;
